// banner
const homeBanana = require('common/pc/images/home_banner_01.png')
// 最新产品
const product01 = require('common/pc/images/product_01.png')
const product02 = require('common/pc/images/product_02.png')
const product_qmz = require('common/pc/images/product_qmz.png')
const productinhim = require('common/pc/images/product_inhim.png')
const grace365Qr = require('common/pc/images/qr-365.png')
// 中间
const homePicture01 = require('common/pc/images/home_picture_01.png')
const homePicture02 = require('common/pc/images/home_picture_02.png')
const homePicture03 = require('common/pc/images/home_picture_03.png')
const culturalBak = require('common/pc/images/cultural_background.png')
// 最新产品
const church01 = require('common/pc/images/church_01.png')
const church02 = require('common/pc/images/church_02.png')
const church03 = require('common/pc/images/church_03.png')

const data = {
  bannerData: {
    imgRul: homeBanana,
    link: '/pc/aboutUs',
    name: '因他科技',
    tip: '专注',
    intro: '主内云生态',
    content: '深耕主内互联网需求，力争前沿'
  },
  newProduce: {
    moreLink: '/pc/produce',
    contentList: [ {
        imgUrl: product_qmz,
        link: 'http://htmlscdn.com/qrcode/stDownGuide/down_qr.png',
        targetBlank: false,
        isQr: true,
        tip: '下载敲门砖APP 解决：传播难、不会传、不好意思传、乱传、别人不听等难题！',
        btnTxt: '立即下载'
      },
      {
        imgUrl: productinhim,
        link: 'http://htmlscdn.com/qrcode/inhimapp/down_qr.png',
        targetBlank: false,
        isQr: true,
        tip: '让你经历从因他到常在他里面In Him的甜蜜；就是着他的话语，建立人与神之间的关系，以致人与人之间的关系也得以重建，并且人与环境的关系恢复和谐。',
        btnTxt: '立即下载'
      },{
        imgUrl: product01,
        link: 'http://htmlscdn.com/img/bibleWebsite/qr_down.png',
        targetBlank: false,
        isQr: true,
        tip: '更简洁、更自由、更全面的灵修工具',
        btnTxt: '立即下载'
      },
     
      {
        imgUrl: product02,
        link: grace365Qr,
        targetBlank: false,
        isQr: true,
        tip: '全新v2.0 版 恩典365 。365天，让我们天天一起活在神的爱和恩典里面',
        btnTxt: '立即下载'
      }    
    ]
  },
  homeIntro: {
    bakImg: culturalBak,
    itemList: [
      {
        isPc: true,
        imgUrl: homePicture01
      },
      {
        isPc: false,
        content: [
          {
            txt: '根植',
            lig: '主内文化'
          },
          {
            txt: '沿袭倍增生命',
            lig: null
          }
        ]
      },
      {
        isPc: true,
        imgUrl: homePicture02
      },
      {
        isPc: false,
        content: [
          {
            txt: '普及',
            lig: '无纸化办公'
          },
          {
            txt: '团队需求定制',
            lig: null
          }
        ]
      },
      {
        isPc: true,
        imgUrl: homePicture03
      },
      {
        isPc: false,
        content: [
          {
            txt: '承接',
            lig: '互联网新时代'
          },
          {
            txt: '我们争做试金石',
            lig: null
          }
        ]
      }
    ]
  },
  customerInfo: [
    {
      imgUrl: church01,
      name: '深圳堂',
      local: '深圳市'
    },
    {
      imgUrl: church02,
      name: '国际礼拜堂',
      local: '宁波市'
    },
    {
      imgUrl: church03,
      name: '侨城堂',
      local: '深圳'
    }
  ]
}
export default data



// WEBPACK FOOTER //
// ./src/common/pc/js/home.js